import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import Wrapper from '../../components/Wrapper';
import { fetchFieldOfficerFarmers } from '../../store/features/fieldOfficerInfo';
import FarmersTable from '../../components/tables/FarmersTable';

const SEARCH_DEBOUNCE_MS = 400;

const FieldOfficerFarmers = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { farmersStatus, farmersError, farmers } = useSelector(
    (state) => state.fieldOfficerInfo
  );

  const [searchInput, setSearchInput] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchTerm(searchInput.trim());
    }, SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    const promise = dispatch(
      fetchFieldOfficerFarmers({ id, search: searchTerm })
    );
    return () => promise.abort();
  }, [dispatch, id, searchTerm]);

  const hasLoadedOnce = useRef(false);
  if (farmersStatus === 'succeeded') hasLoadedOnce.current = true;

  const isRefetching = farmersStatus === 'loading' && hasLoadedOnce.current;
  const showTable = farmersStatus === 'succeeded' || isRefetching;

  const handleClear = () => {
    setSearchInput('');
    setSearchTerm('');
  };

  return (
    <Wrapper>
      <div className='reports-container py-4 w-100'>
        <div className='d-flex flex-column flex-md-row justify-content-between mb-3 w-100'>
          <h1 className='fw-bolder'>Farmers of field officer</h1>

          <div className='d-flex justify-content-end align-items-center mt-3 m-md-0'>
            <InputGroup style={{ minWidth: 280 }}>
              <Form.Control
                type='text'
                placeholder='Search name, mobile, city, pincode...'
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                aria-label='Search farmers'
              />
              {searchInput && (
                <Button variant='outline-secondary' onClick={handleClear}>
                  Clear
                </Button>
              )}
            </InputGroup>
          </div>
        </div>

        {farmersStatus === 'failed' && (
          <p className='text-danger'>
            {farmersError || 'Failed to load farmers.'}
          </p>
        )}

        {showTable ? (
          <div style={{ opacity: isRefetching ? 0.5 : 1, transition: 'opacity .15s' }}>
            <FarmersTable users={farmers} />
          </div>
        ) : (
          farmersStatus !== 'failed' && <h2>Loading...</h2>
        )}
      </div>
    </Wrapper>
  );
};

export default FieldOfficerFarmers;